var r=function(r){return r};export{r as default};
//# sourceMappingURL=identity.js.map
